export default function TwitchChatbotConnecting() {
  return (
    <div className="p-4 py-16 flex justify-center items-center">
      <span className="loading loading-spinner loading-md"></span>
    </div>
  );
}
